import { forwardRef, InputHTMLAttributes, ReactNode } from "react"
import { classNames } from "utils/ClassNames"

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Render an invalid state (red ring). */
  hasError?: boolean
  /** Optional icon rendered inside the input on the left. */
  leadingIcon?: ReactNode
}

const inputBase =
  "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm/6 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-500"

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { hasError = false, leadingIcon, className, ...props },
  ref
) {
  const ringClasses = hasError
    ? "ring-red-300 focus:ring-red-500 dark:ring-red-500/60"
    : "ring-gray-300 focus:ring-primary-600 dark:ring-gray-600 dark:focus:ring-primary-500"

  const input = (
    <input
      ref={ref}
      className={classNames(inputBase, ringClasses, !!leadingIcon && "pl-10", className)}
      {...props}
    />
  )

  if (!leadingIcon) return input

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
        {leadingIcon}
      </div>
      {input}
    </div>
  )
})
